import { render, staticRenderFns } from "./address-suggestions.vue?vue&type=template&id=75ac418f&scoped=true"
import script from "./address-suggestions.vue?vue&type=script&lang=js"
export * from "./address-suggestions.vue?vue&type=script&lang=js"
import style0 from "./address-suggestions.vue?vue&type=style&index=0&id=75ac418f&prod&lang=css"
import style1 from "./address-suggestions.vue?vue&type=style&index=1&id=75ac418f&prod&scoped=true&lang=css"
import style2 from "./address-suggestions.vue?vue&type=style&index=2&id=75ac418f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ac418f",
  null
  
)

export default component.exports